import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILocationsState } from './locations-state';
import { StateSlice } from '../state-slice';
import { IListState } from '../shared/list/list.state';
import { getLocationEntities } from '../shared/entities/entities-selectors';
import { Location } from '@core/models/location/location';

export const selectLocationState = createFeatureSelector<ILocationsState>(StateSlice.LOCATION);

export const getLocationList = createSelector(
    selectLocationState,
    (state: ILocationsState): IListState =>  state.companyLocations
);

export const getLocationIds = createSelector(
    selectLocationState,
    (state: ILocationsState) =>  state.companyLocations.ids
);

export const getViewedLocationId = createSelector(
    selectLocationState,
    (state: ILocationsState): string =>  state.viewedLocationId
);

export const getLocations = createSelector(
    [getLocationIds, getLocationEntities],
    (locationIds: string[], locationEntities: { [id: string]: Location}) => {
        return locationIds.map((locationId: string) => locationEntities[locationId])
    }
);

export const isMultiLocation = createSelector(
    [getLocations], (locations: Location[]) => {
        return locations?.length > 1;
    });

export const getDefaultLocation = createSelector(
    [getLocationIds, getLocationEntities],
    (locationIds: string[], locationEntities: { [id: string]: Location}) => {
        return locationIds?.length ? locationEntities[locationIds[0]] : null
    }
);

export const isFetching = createSelector(
    getLocationList,
    (locationList: IListState): boolean =>  locationList.isFetching
);

export const getViewedLocation = createSelector(
    [getViewedLocationId, getLocationEntities],
    (locationId: string, locationEntities: { [id: string]: Location}) => {
        return (locationId && locationEntities.hasOwnProperty(locationId) && locationEntities[locationId]) || null;
    }
);
